var links = [
    'https://yuriwoori.com/products/rice-facial-deep-cleansing-foam',
    'https://yuriwoori.com/collections/hand-cream',
    'https://yuriwoori.com/collections/the-hydration-trio'
];

$('.hero-slider').on('click', '.slick-slide', function () {

    var index = parseInt($(this).attr('data-slick-index'));

    if (index >= 0) {
        window.location.href = links[index];
    }

});


$('.maskBtn').on('click', function () {
    window.location.href = "https://yuriwoori.com/collections/face-mask";
});

$('.bundleBtn').on('click', function () {
    window.location.href = "https://yuriwoori.com/products/build-your-own-bundle";
});

$('.shopBtn').on('click', function () {
    window.location.href = "https://yuriwoori.com/collections/all";
});

$('.glowBtn').on('click', function () {
    window.location.href = "https://yuriwoori.com/collections/glow";
});

document.addEventListener('DOMContentLoaded', function () {
    console.log("clarity1");
    
    /*setTimeout(function () {
        console.log("Before style injection");

        const style = document.createElement('style');
        style.textContent = `
            [data-testid="entrypoint"] {
                bottom: 120px !important;
                margin-bottom: 0 !important;
            }
        `;

        document.head.appendChild(style);

        console.log("After style injection");
    }, 10000);*/

    setTimeout(function () {
        //alert("came");
        var element = document.getElementsByClassName("items-end");
        for (var i = 0; i < element.length; i++) {
            element[i].classList.add('bottomMarginClass');
        }



        //element.classList.add("");
    }, 20000);
    
});

document.querySelectorAll('select[name="sort_by"] option').forEach(option => {
    if (
        option.value === 'created-ascending' ||
        option.value === 'created-descending'
    ) {
        option.remove();
    }
});